/** Full product catalog for Estore-only pages (shop, product, cart). */

export function effectivePrice(p) {
  if (!p || !p.discount) return p.price;
  return Math.round(p.price * (1 - p.discount / 100));
}

export const estoreCatalog = [
  {
    id: 1,
    title: "Wireless Headphones",
    price: 149,
    discount: 12,
    rating: 4.6,
    category: "Electronics",
    brand: "Aural",
    image: "https://images.unsplash.com/photo-1505740420928-5e560c06d30e?w=600&h=600&fit=crop&q=80",
    images: [
      "https://images.unsplash.com/photo-1505740420928-5e560c06d30e?w=800&h=800&fit=crop&q=80",
      "https://images.unsplash.com/photo-1484704849700-f032a568e944?w=800&h=800&fit=crop&q=80",
      "https://images.unsplash.com/photo-1546435770-a3e426bf472b?w=800&h=800&fit=crop&q=80",
    ],
    description: "Balanced sound profile, plush ear cushions, and all-day battery for focus sessions.",
  },
  {
    id: 2,
    title: "Ceramic Desk Lamp",
    price: 89,
    discount: 0,
    rating: 4.4,
    category: "Home",
    brand: "Lumen",
    image: "https://images.unsplash.com/photo-1507473885765-e6ed057f782c?w=600&h=600&fit=crop&q=80",
    images: [
      "https://images.unsplash.com/photo-1507473885765-e6ed057f782c?w=800&h=800&fit=crop&q=80",
      "https://images.unsplash.com/photo-1513506003901-1e6a229e2d15?w=800&h=800&fit=crop&q=80",
    ],
    description: "Matte ceramic base with warm adjustable LED — minimal footprint for any desk.",
  },
  {
    id: 3,
    title: "Leather Tote",
    price: 210,
    discount: 18,
    rating: 4.8,
    category: "Accessories",
    brand: "Atelier",
    image: "https://images.unsplash.com/photo-1590874103328-eac38a683ce7?w=600&h=600&fit=crop&q=80",
    images: [
      "https://images.unsplash.com/photo-1590874103328-eac38a683ce7?w=800&h=800&fit=crop&q=80",
      "https://images.unsplash.com/photo-1590874103312-2fb5cef8cce7?w=800&h=800&fit=crop&q=80",
    ],
    description: "Full-grain leather, reinforced handles, and a clean silhouette for work or travel.",
  },
  {
    id: 4,
    title: "Trail Running Shoes",
    price: 165,
    discount: 10,
    rating: 4.5,
    category: "Sports",
    brand: "Stride",
    image: "https://images.unsplash.com/photo-1542291026-7eec264c27ff?w=600&h=600&fit=crop&q=80",
    images: [
      "https://images.unsplash.com/photo-1542291026-7eec264c27ff?w=800&h=800&fit=crop&q=80",
      "https://images.unsplash.com/photo-1606107557195-0e29a4b5b4aa?w=800&h=800&fit=crop&q=80",
    ],
    description: "Responsive midsole and breathable mesh for mixed terrain without bulk.",
  },
  {
    id: 5,
    title: "Smart Watch",
    price: 279,
    discount: 15,
    rating: 4.3,
    category: "Electronics",
    brand: "Pulse",
    image: "https://images.unsplash.com/photo-1523275335684-37898b6baf30?w=600&h=600&fit=crop&q=80",
    images: [
      "https://images.unsplash.com/photo-1523275335684-37898b6baf30?w=800&h=800&fit=crop&q=80",
      "https://images.unsplash.com/photo-1434493789847-2f02dc6ca35d?w=800&h=800&fit=crop&q=80",
    ],
    description: "AMOLED display, sleep tracking, and a week of battery in a slim case.",
  },
  {
    id: 6,
    title: "Linen Throw",
    price: 64,
    discount: 0,
    rating: 4.2,
    category: "Home",
    brand: "Hearth",
    image: "https://images.unsplash.com/photo-1584100936595-c9d332d86e7f?w=600&h=600&fit=crop&q=80",
    images: [
      "https://images.unsplash.com/photo-1584100936595-c9d332d86e7f?w=800&h=800&fit=crop&q=80",
      "https://images.unsplash.com/photo-15550414604-a4a4c5c0e8c8?w=800&h=800&fit=crop&q=80",
    ],
    description: "European flax linen with a soft wash — breathable year-round.",
  },
  {
    id: 7,
    title: "Espresso Glass Set",
    price: 42,
    discount: 8,
    rating: 4.7,
    category: "Home",
    brand: "Barista Co.",
    image: "https://images.unsplash.com/photo-1514228742587-6b1558fcca3d?w=600&h=600&fit=crop&q=80",
    images: [
      "https://images.unsplash.com/photo-1514228742587-6b1558fcca3d?w=800&h=800&fit=crop&q=80",
      "https://images.unsplash.com/photo-1495474472287-4d71bcdd2085?w=800&h=800&fit=crop&q=80",
    ],
    description: "Double-walled borosilicate cups — keeps shots hot, fingers cool.",
  },
  {
    id: 8,
    title: "Studio Microphone",
    price: 199,
    discount: 20,
    rating: 4.9,
    category: "Electronics",
    brand: "Sterling",
    image: "https://images.unsplash.com/photo-1590602847861-f357a9332bbc?w=600&h=600&fit=crop&q=80",
    images: [
      "https://images.unsplash.com/photo-1590602847861-f357a9332bbc?w=800&h=800&fit=crop&q=80",
      "https://images.unsplash.com/photo-1589492477829-5e65395b66cc?w=800&h=800&fit=crop&q=80",
    ],
    description: "Cardioid capsule tuned for vocals and streaming with low self-noise.",
  },
  {
    id: 9,
    title: "Yoga Mat",
    price: 50,
    discount: 0,
    rating: 4.4,
    category: "Sports",
    brand: "Zenith",
    image: "https://images.unsplash.com/photo-1544367567-0f2fcb009e0b?w=600&h=600&fit=crop&q=80",
    images: [
      "https://images.unsplash.com/photo-1544367567-0f2fcb009e0b?w=800&h=800&fit=crop&q=80",
      "https://images.unsplash.com/photo-1601925260368-ae2f83cf8b7f?w=800&h=800&fit=crop&q=80",
    ],
    description: "Dense natural rubber base with a microfibre top — stable and quiet.",
  },
  {
    id: 10,
    title: "Sunglasses",
    price: 120,
    discount: 14,
    rating: 4.5,
    category: "Accessories",
    brand: "Sol",
    image: "https://images.unsplash.com/photo-1572635196237-14b3f281503f?w=600&h=600&fit=crop&q=80",
    images: [
      "https://images.unsplash.com/photo-1572635196237-14b3f281503f?w=800&h=800&fit=crop&q=80",
      "https://images.unsplash.com/photo-1511499767150-a48a237f0083?w=800&h=800&fit=crop&q=80",
    ],
    description: "Polarised lenses in a slim titanium frame — featherlight fit.",
  },
  {
    id: 11,
    title: "Cashmere Crew",
    price: 138,
    discount: 0,
    rating: 4.6,
    category: "Men",
    brand: "Layr",
    image: "https://images.unsplash.com/photo-1622445275463-afa665abfd4d?w=600&h=600&fit=crop&q=80",
    images: [
      "https://images.unsplash.com/photo-1622445275463-afa665abfd4d?w=800&h=800&fit=crop&q=80",
      "https://images.unsplash.com/photo-1617127365659-c47fa864d8bc?w=800&h=800&fit=crop&q=80",
    ],
    description: "Grade-A cashmere, tight knit, raglan shoulder for a modern drape.",
  },
  {
    id: 12,
    title: "Kids Backpack",
    price: 48,
    discount: 0,
    rating: 4.5,
    category: "Kids",
    brand: "TinyGear",
    image: "https://images.unsplash.com/photo-1553062407-98eeb64c6a62?w=600&h=600&fit=crop&q=80",
    images: [
      "https://images.unsplash.com/photo-1553062407-98eeb64c6a62?w=800&h=800&fit=crop&q=80",
      "https://images.unsplash.com/photo-1622560460105-9620fdf98902?w=800&h=800&fit=crop&q=80",
    ],
    description: "Lightweight nylon with padded straps and reflective trim for school days.",
  },
  {
    id: 13,
    title: "Ceramic Vase Set",
    price: 72,
    discount: 10,
    rating: 4.3,
    category: "Home",
    brand: "Kiln",
    image: "https://images.unsplash.com/photo-1578500494199-246b632172fe?w=600&h=600&fit=crop&q=80",
    images: [
      "https://images.unsplash.com/photo-1578500494199-246b632172fe?w=800&h=800&fit=crop&q=80",
      "https://images.unsplash.com/photo-1603653407188-5fc6f0e8f98f?w=800&h=800&fit=crop&q=80",
    ],
    description: "Hand-glazed trio in complementary tones — scale-ready for shelves or tables.",
  },
  {
    id: 14,
    title: "Merino Wrap Cardigan",
    price: 124,
    discount: 0,
    rating: 4.7,
    category: "Women",
    brand: "Layr",
    image: "https://images.unsplash.com/photo-1583394838336-acd977736f90?w=600&h=600&fit=crop&q=80",
    images: [
      "https://images.unsplash.com/photo-1583394838336-acd977736f90?w=800&h=800&fit=crop&q=80",
      "https://images.unsplash.com/photo-1434389677669-e08b4cac3105?w=800&h=800&fit=crop&q=80",
    ],
    description: "Fine merino with an open front — easy layer for office or weekend.",
  },
  {
    id: 15,
    title: "Vitamin C Serum",
    price: 38,
    discount: 5,
    rating: 4.4,
    category: "Beauty",
    brand: "Glow Lab",
    image: "https://images.unsplash.com/photo-1556228578-8c89e73adf91?w=600&h=600&fit=crop&q=80",
    images: [
      "https://images.unsplash.com/photo-1556228578-8c89e73adf91?w=800&h=800&fit=crop&q=80",
      "https://images.unsplash.com/photo-1570194065650-d99fb4b38b17?w=800&h=800&fit=crop&q=80",
    ],
    description: "15% L-ascorbic acid in a featherlight base — morning radiance without stickiness.",
  },
];

export function getEstoreProductById(id) {
  const n = Number(id);
  return estoreCatalog.find((p) => p.id === n) ?? null;
}

export const searchCatalog = estoreCatalog.map((p) => ({
  id: p.id,
  title: p.title,
  price: effectivePrice(p),
  category: p.category,
  image: p.image,
}));

export const featuredProducts = estoreCatalog.slice(0, 8);
